// extracted by mini-css-extract-plugin
module.exports = {"container":"test-content_container__k0snv","border":"test-content_border__3BFPZ","full":"test-content_full__1EJTc"};